// extracted by mini-css-extract-plugin
export default {"sidenav":"SideList_sidenav__IfuCp"};